<template>
  <div>
    <base-title :title="StringLanguage.myAccount">
      <base-button
        :class="!!isMobile && 'reverse w-100'"
        design="two"
        v-if="isMasterOrAdmin()"
        text="Gerenciar usuários"
        @click="changeRoute('usuarios')"
      />
    </base-title>
    <base-box>
      <div class="row align-stretch" :class="{ 'd-flex': !isMobile }">
        <div
          v-if="!isMobile || activeTab == 'ACCOUNT'"
          class="col-xs-12 col-lg-5"
          :style="
            !isMobile &&
            'border-right: 1px solid #ffffff1f; padding-right: 40px; margin-right: 25px'
          "
        >
          <p class="icon">
            <i class="fal fa-user"></i>
          </p>
          <p class="account-title">Meus dados</p>
          <div class="row" id="store">
            <div class="col-xs-6" :class="!!isMobile ? 'pr_7' : ''">
              <div class="account-info-box">
                <p class="w-100 text-center mb_10 label">NOME DE USUÁRIO</p>
                <p class="w-100 text-center value">{{ oAccount.username }}</p>
              </div>
            </div>
            <div class="col-xs-6" :class="!!isMobile ? 'pl_7' : ''">
              <div class="account-info-box">
                <p class="w-100 text-center mb_10 label">URL DA LOJA</p>
                <p class="w-100 text-center value">/{{ environmentAlias }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex justify-center">
            <base-button
              design="four"
              text="Alterar senha"
              class="w-100"
              @click="
                drawers.updatePassword.open = !drawers.updatePassword.open
              "
            />
            <base-button
              v-if="isMaster()"
              design="four"
              :text="
                !!isMobile ? 'Config. avançadas' : 'Configurações avançadas'
              "
              class="w-100 ml_15"
              @click="
                drawers.advancedConfigurations.open =
                  !drawers.advancedConfigurations.open
              "
            />
          </div>
        </div>

        <div class="col-xs-12" v-if="!!isMobile">
          <div class="hr" />
        </div>

        <div class="col-xs-12 col-lg-7">
          <custom-form ref="baseForm">
            <div class="row">
              <div class="col-xs-12 mb_5">
                <name-input
                  :label="StringLanguage.name"
                  v-model="oAccount.name"
                  design="two"
                />
              </div>
              <div class="col-xs-12 mb_5">
                <div class="d-flex input-edit">
                  <email-input
                    :label="StringLanguage.email"
                    :disabled="isMaster()"
                    v-model="oAccount.email"
                    class="w-100"
                    design="two"
                  />
                  <div
                    v-if="isMaster()"
                    @click="drawerEmail.open = !drawerEmail.open"
                    class="edit-input"
                    title="Editar e-mail"
                  >
                    <i class="fal fa-pen"></i>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 mb_5">
                <div class="d-flex input-edit">
                  <cellphone-input
                    :label="StringLanguage.phone"
                    :mask="['(##) #####-####']"
                    v-model="oAccount.phone"
                    :disabled="isMaster()"
                    class="w-100"
                    design="two"
                  />
                  <div
                    v-if="isMaster()"
                    @click="drawerPhone.open = !drawerPhone.open"
                    class="edit-input"
                    title="Editar telefone"
                  >
                    <i class="fal fa-pen"></i>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <birthday-input
                  label="Aniversário"
                  v-model="oAccount.birthdate"
                  design="two"
                  class="mb_0"
                />
              </div>
            </div>
          </custom-form>
        </div>
      </div>
    </base-box>

    <div class="d-flex justify-end" v-if="hasChanges()">
      <base-button design="save" @click="save" />
    </div>

    <base-drawer
      title="Editar e-mail"
      :open="drawerEmail.open"
      :close="drawerEmail.close"
      :closeValidation="onCloseDrawer"
    >
      <base-card v-if="stage == 0">
        <base-question text="Informe o novo e-mail" class="mb_10" />
        <custom-form ref="emailForm">
          <email-input
            placeholder="exemplo@email.com"
            ref="email"
            class="mb_10"
            v-model="newEmail"
          />
        </custom-form>
        <base-message
          v-if="this.$refs.emailForm && !this.$refs.emailForm.messages.length"
          class="mt_15"
          >Ao confirmar, enviaremos um código para seu e-mail para
          validá-lo.</base-message
        >
      </base-card>

      <base-card v-else>
        <base-question text="Informe o código enviado" class="mb_15" />
        <custom-form ref="emailCodeForm">
          <confirm-code-input
            class="mb_10"
            ref="emailCode"
            v-model="emailCode"
          />
        </custom-form>

        <p v-if="emailTimer" class="send-code">
          Reenviar código ({{ secondsToMinutesString(emailTimer) }})
        </p>
        <p v-else class="send-code" @click="requestEmailCode()">
          Reenviar código
        </p>
      </base-card>

      <div slot="footer">
        <base-button
          v-if="stage === 0"
          :text="StringLanguage.confirm"
          @click="validateEmail() && requestEmailCode()"
          class="w-100"
        />
        <base-button
          v-else
          :text="StringLanguage.save"
          @click="validateEmailCode()"
          class="w-100"
        />
      </div>
    </base-drawer>

    <base-drawer
      title="Editar telefone"
      :open="drawerPhone.open"
      :close="drawerPhone.close"
      :closeValidation="onCloseDrawer"
    >
      <base-card v-if="stage == 0">
        <base-question text="Informe o novo telefone" class="mb_10" />
        <custom-form ref="newPhoneForm">
          <cellphone-input ref="newPhone" v-model="newPhone" />
        </custom-form>
        <base-message
          v-if="
            this.$refs.newPhoneForm && !this.$refs.newPhoneForm.messages.length
          "
          class="mt_15"
          >Ao confirmar, enviaremos um código via SMS para seu celular para
          validá-lo.</base-message
        >
      </base-card>

      <base-card v-else>
        <base-question text="Informe o código enviado" class="mb_15" />
        <custom-form ref="phoneCodeForm">
          <confirm-code-input
            class="mb_10"
            ref="phoneCode"
            v-model="phoneCode"
          />
        </custom-form>

        <p v-if="phoneTimer" class="send-code">
          Reenviar código ({{ secondsToMinutesString(phoneTimer) }})
        </p>
        <p v-else class="send-code" @click="requestPhoneCode()">
          Reenviar código
        </p>
      </base-card>

      <div slot="footer">
        <base-button
          v-if="stage === 0"
          :text="StringLanguage.confirm"
          @click="validatePhone() && requestPhoneCode()"
          class="w-100"
        />
        <base-button
          v-else
          :text="StringLanguage.save"
          @click="validatePhoneCode()"
          class="w-100"
        />
      </div>
    </base-drawer>

    <update-subscription-drawer
      :open="drawers.updateSubscriptionDrawer.open"
      :close="drawers.updateSubscriptionDrawer.close"
      @close="
        drawers.updateSubscriptionDrawer.close =
          !drawers.updateSubscriptionDrawer.close
      "
    />

    <base-drawer
      :title="
        drawers.advancedConfigurations.open
          ? drawers.deleteAccount.open
            ? 'Excluir loja'
            : 'Configurações avançadas'
          : 'Configurações avançadas'
      "
      :open="drawers.advancedConfigurations.open"
      :close="drawers.advancedConfigurations.close"
      @onClose="drawers.deleteAccount.open = false"
    >
      <base-card>
        <div class="grid">
          <div
            class="option"
            @click="drawers.deleteAccount.open = !drawers.deleteAccount.open"
            v-if="!drawers.deleteAccount.open"
          >
            <i class="fal fa-times fs-24" />
            <p>Excluir conta</p>
          </div>
        </div>

        <div v-if="drawers.deleteAccount.open">
          <div class="infos">
            <i class="far fa-exclamation-circle" />
            <p class="attention">ATENÇÃO!</p>
            <p class="deactivate">Deletar sua conta significa</p>
          </div>

          <div class="losses">
            <p>- Perder seu cardápio digital</p>
            <p>- Perder todos os seus pedidos realizados</p>
            <p>- Perder todos os seus clientes cadastrados</p>
            <p>- Perder todos os relatórios</p>
            <p>- Entre outras perdas</p>
          </div>

          <p class="date">
            Ao deletar você poderá reativar sua conta em até 30 dias
            ({{ oneMonthLaterDate }}), para realizar esta reativação basta realizar um login.
          </p>

          <base-button
            text="Voltar para segurança"
            class="w-100 big"
            @click="drawers.deleteAccount.open = !drawers.deleteAccount.open"
          />
          <div class="d-flex align-center justify-center">
            <p
              class="delete-account"
              v-if="storeConfiguration.published && isMaster()"
              @click="deleteStore()"
            >
              Deletar minha conta
            </p>
          </div>
        </div>
      </base-card>
    </base-drawer>

    <password-update
      :open="drawers.updatePassword.open"
      :close="drawers.updatePassword.close"
      @updatePassword="updatePassword"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { TheMask } from 'vue-the-mask';
import Vue from 'vue';
import { Role } from 'easyjs/lib/Role/Group';
import User from 'easyjs/lib/Schema/Account/User';
import { getXAPIEnv, getXUserKey } from '@/plugins/account';
import AccountPassword from '@/containers/Account/AccountPassword';
import AccountPayments from '@/containers/Account/AccountPayments';
import StoreAPI from '@/api/store';
import Drawer from '@/components/Drawer';
import AccountAPI from '@/api/account';
import UserAPI from '@/api/user';

import Account from '@/plugins/core/schema/configurations/account/Account';
import Utils from '@/utils';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseMessage from '@/components/Message';
import BaseQuestion from '@/components/Question';
import BaseTabs from '@/components/Tabs';
import UpdateSubscriptionDrawer from '@/containers/Account/UpdateSubscriptionDrawer';
import PasswordUpdate from '@/containers/Account/Password/Update';

import CustomForm from '@/containers/Form';
import NameInput from '@/containers/Inputs/NameInput';
import CellphoneInput from '@/containers/Inputs/CellphoneInput';
import EmailInput from '@/containers/Inputs/EmailInput';
import BirthdayInput from '@/containers/Inputs/BirthdayInput';
import ConfirmCodeInput from '@/containers/Inputs/ConfirmCodeInput';

const tabs = [{ name: 'Meus Dados', value: 'ACCOUNT' }];

export default {
  data() {

    const oneMonthLaterDate = new Date;
    oneMonthLaterDate.setMonth(oneMonthLaterDate.getMonth()+1);

    return {
      Utils,
      oneMonthLaterDate: oneMonthLaterDate.toLocaleDateString(),
      environmentAlias: getXAPIEnv(),
      drawerEmail: {
        open: false,
        close: false,
      },
      drawerPhone: {
        open: false,
        close: false,
      },
      drawers: {
        updatePassword: {
          open: false,
          close: false,
        },
        updateSubscriptionDrawer: {
          open: false,
          close: false,
        },
        advancedConfigurations: {
          open: false,
          close: false,
        },
        deleteAccount: {
          open: false,
          close: false,
        },
      },
      tabs,
      activeTab: 'ACCOUNT',
      stage: 0,
      newEmail: '',
      emailCode: null,
      emailTimer: 0,
      newPhone: '',
      phoneCode: null,
      phoneTimer: 0,
      isPublished: null,
      originalAccount: new User({}),
      oAccount: new User({}),
      changePassword: {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      },
    };
  },
  watch: {
    drawerEmail: {
      deep: true,
      handler(newV) {
        // pega referência de input de email para dar foco
        if (newV.open && this.$refs.emailForm) {
          this.$refs.email.$refs.baseinput.focus();
        }
      },
    },
    drawerPhone: {
      deep: true,
      handler(newV) {
        // pega referência de input de phone para dar foco
        if (newV.open && this.$refs.newPhoneForm) {
          this.$refs.newPhone.$refs.baseinput.focus();
        }
      },
    },
  },
  created() {
    const self = this;
    self.me();
    this.loadPublishStatus();
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      if (this.isInputsValid()) {
        this.save({ ...this.oAccount }).then(() => {
          next();
        });
      } else {
        return next();
      }
    }

    return next();
  },
  methods: {
    hasChanges() {
      return (
        JSON.stringify(this.originalAccount) != JSON.stringify(this.oAccount)
      );
    },
    setFormErrorValidation(form, input, codeMessage) {
      this.$refs[form].setErrorValidation(
        this.$refs[input].inputId,
        codeMessage
      );
      this.$refs[input].isValid = false;
    },
    removeFormErrorValidation(form, input) {
      this.$refs[form].removeErrorValidation(this.$refs[input].inputId);
      this.$refs[input].isValid = true;
    },
    isInputsValid() {
      // validar erros, se houver dá return false;
      this.$refs.baseForm.validateInputs();
      if (this.$refs.baseForm.messages.length) {
        return false;
      }

      return true;
    },
    me() {
      const self = this;
      AccountAPI.me().then((response) => {
        if (response._data && response._data.birthdate) {
          response._data.birthdate = Utils.iso2Br(response._data.birthdate);
        }
        self.set(response);
      });
    },
    changeRoute(routeName, params) {
      if (params) {
        return this.$router.push({ name: routeName, params });
      }
      this.$router.push({ name: routeName });
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        alert(response.getErrors([])[0]);
        return false;
      }
      if (response.getData({}) || false) {
        const account = response.getData(new User({}));
        Vue.set(this, 'originalAccount', new User(account));
        Vue.set(this, 'oAccount', new User({ ...account }));
        Vue.set(this, 'newEmail', '');
        Vue.set(this, 'newPhone', '');
        Vue.set(this, 'changePassword', {
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        });
      } else {
        Vue.set(this, 'oAccount', new User({}));
      }
    },
    loadPublishStatus() {
      StoreAPI.storeGetConfiguration('published').then((response) => {
        this.isPublished = response.getData({ published: false }).published;
      });
    },

    async deleteStore() {
      const response = await StoreAPI.delete();
      if(response.getCode(500) == 200) {
        setXUserKey();
        this.$store.dispatch('account/cleanUser');
        this.$router.push({ name: 'login' });
        return;
      }
      alert(response.getErrors(['Ocorreu um erro ao solicitar a exclusão da loja!'])[0]);
    },

    validateEmail() {
      if (this.newEmail === this.originalAccount.email) {
        this.setFormErrorValidation('emailForm', 'email', '2001');
        return false;
      }

      const user = new User({ email: this.newEmail });
      try {
        user.validate(['email']);
        return true;
      } catch (err) {
        return false;
      }
    },

    async requestEmailCode() {
      this.stage = 1;
      this.emailCode = null;
      const response = await AccountAPI.requestEmailCode(this.newEmail, false);
      if (!response.getData({ success: false }).success) {
        this.setFormErrorValidation('emailCodeForm', 'emailCode', '8002');
        return false;
      }

      // pega referência de input de código do email para dar foco
      this.$refs.emailCode.$refs.baseinput.focus();

      this.emailTimer = 60;
      const timerId = setInterval(() => {
        if (this.emailTimer > 0) {
          this.emailTimer--;
        } else {
          clearInterval(timerId);
        }
      }, 1000);

      return true;
    },

    async validateEmailCode() {
      if (!this.emailCode) {
        return false;
      }

      const response = await AccountAPI.validateEmailCode(
        this.emailCode,
        this.newEmail,
        false
      );
      if (!response.getData({ success: false }).success) {
        this.emailCode = null;
        this.setFormErrorValidation('emailCodeForm', 'emailCode', '8000');
        return false;
      }

      this.save({ email: this.newEmail });
      this.drawerEmail.close = true;
      return true;
    },

    validatePhone() {
      if (this.newPhone === this.originalAccount.phone) {
        this.setFormErrorValidation('newPhoneForm', 'phone', '3004');
        return false;
      }

      this.$refs.newPhoneForm.validateInputs();
      if (this.$refs.newPhoneForm.messages.length) {
        return false;
      }

      const user = new User({ phone: this.newPhone });
      try {
        user.validate(['phone']);
        return true;
      } catch (err) {
        return false;
      }
    },

    async requestPhoneCode() {
      this.stage = 1;
      this.phoneCode = null;
      const response = await AccountAPI.requestPhoneCode(this.newPhone, false);
      if (!response.getData({ success: false }).success) {
        this.setFormErrorValidation('phoneCodeForm', 'phoneCode', '8002');
        return false;
      }

      // pega referência de input de phone para dar foco
      this.$refs.phoneCode.$refs.baseinput.focus();

      this.phoneTimer = 60;
      const timerId = setInterval(() => {
        if (this.phoneTimer > 0) {
          this.phoneTimer--;
        } else {
          clearInterval(timerId);
        }
      }, 1000);
      return true;
    },

    async validatePhoneCode() {
      if (!this.phoneCode) {
        this.setFormErrorValidation('phoneCodeForm', 'phoneCode', '8000');
        return false;
      }

      this.$refs.phoneCodeForm.validateInputs();
      if (this.$refs.phoneCodeForm.messages.length) {
        return false;
      }

      const response = await AccountAPI.validatePhoneCode(
        this.phoneCode,
        this.newPhone,
        false
      );
      if (!response.getData({ success: false }).success) {
        this.phoneCode = null;
        this.setFormErrorValidation('phoneCodeForm', 'phoneCode', '8000');
        return false;
      }

      this.save({ phone: this.newPhone });
      this.drawerPhone.close = true;
      return true;
    },

    secondsToMinutesString(seconds) {
      const finalMinutes = (seconds - (seconds % 60)) / 60;
      const finalSeconds = seconds % 60;
      return `${`${finalMinutes}`.padStart(
        2,
        '0'
      )}:${`${finalSeconds}`.padStart(2, '0')}`;
    },

    onCloseDrawer() {
      if (this.stage === 0) {
        this.resetDrawerData();
        return true;
      }

      return confirm('Tem certeza que deseja cancelar a alteração?').then(
        (response) => {
          if (response) {
            this.resetDrawerData();
            return true;
          }
          return false;
        }
      );
    },

    resetDrawerData() {
      this.stage = 0;

      this.drawerEmail.open = false;
      this.drawerEmail.close = false;
      this.newEmail = '';
      this.emailCode = null;
      this.emailTimer = 0;

      this.drawerPhone.open = false;
      this.drawerPhone.close = false;
      this.newPhone = '';
      this.phoneCode = null;
      this.phoneTimer = 0;

      this.drawers.updatePassword.close = !this.drawers.updatePassword.close;
    },

    save(data) {
      const validateAccount = this.isUserValid();
      const isMasterRole = this.isMaster();
      const birthdate = this.oAccount.birthdate
        ? Utils.br2Iso(this.oAccount.birthdate)
        : null;

      if (!validateAccount) return;

      if (isMasterRole) {
        return UserAPI.update(this.originalAccount.id, {
          ...data,
          name: this.oAccount.name,
          username: this.originalAccount.username,
          currentGroup: this.originalAccount.group,
          birthdate,
          login_hash: getXUserKey(),
        }).then((response) => {
          if (response.getErrors([]).length > 0) {
            return;
          }
          alert(StringLanguage.saveSuccess);
          this.resetDrawerData();
          this.me();
        });
      }
      return UserAPI.update(this.oAccount.id, {
        ...data,
        name: this.oAccount.name,
        username: this.oAccount.username,
        currentGroup: this.oAccount.group,
        email: this.oAccount.email,
        phone: this.oAccount.phone,
        birthdate,
        login_hash: getXUserKey(),
      }).then((response) => {
        if (response.getErrors([]).length > 0) {
          alert(response.getErrors(['Ocorreu um erro ao salvar os dados!'])[0]);
          return;
        }
        this.resetDrawerData();
        this.me();
      });
    },

    isUserValid() {
      try {
        const user = this.oAccount;

        if (user.email) {
          user.validate(['email']);
        }

        if (user.name) {
          user.validate(['name']);
        }

        if (user.phone) {
          user.validate(['phone']);
        }

        return true;
      } catch (err) {
        alert(err.message);
        setTimeout(() => {
          location.reload();
        }, 200);
      }
    },

    isMaster() {
      return this.originalAccount.group === Role.MASTER;
    },
    isMasterOrAdmin() {
      return (
        this.originalAccount.group === Role.MASTER ||
        this.originalAccount.group === Role.ADMIN
      );
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    updatePassword(currentPassword, newPassword) {
      const birthdate = this.oAccount.birthdate
        ? Utils.br2Iso(this.oAccount.birthdate)
        : null;
      UserAPI.update(this.originalAccount.id, {
        newPassword,
        currentPassword,
        name: this.originalAccount.name,
        username: this.originalAccount.username,
        currentGroup: this.originalAccount.group,
        login_hash: getXUserKey(),
        birthdate,
      }).then((response) => {
        if (response.getErrors([]).length > 0) {
          alert(response.getErrors(['Ocorreu um erro ao salvar os dados!'])[0]);
          return;
        }
        this.resetDrawerData();
        this.me();
      });
    },
  },
  computed: {
    ...mapState({
      storeConfiguration: (state) => state.store.configurations,
      isMobile: (state) => state.store.isMobile,
    }),
  },
  components: {
    TheMask,
    AccountPassword,
    AccountPayments,
    Drawer,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseMessage,
    BaseQuestion,
    UpdateSubscriptionDrawer,
    BaseTabs,
    PasswordUpdate,
    CustomForm,
    NameInput,
    CellphoneInput,
    EmailInput,
    BirthdayInput,
    ConfirmCodeInput,
  },
};
</script>

<style scoped>
.icon {
  font-size: 2.2em;
  color: var(--icon-inactive);
  background: var(--box-up);
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: auto;
}
.account-title {
  color: #ffffff80;
  width: 100%;
  margin-bottom: 35px;
  margin-top: 15px;
  text-align: center;
  line-height: 17px;
  font-size: 1.4em;
  font-weight: bold;
  margin-top: 15px;
}
.account-info-box {
  background: #45484d61;
  padding: 15px;
  border-radius: 5px;
}

.account-info-box p:first-child {
  font-weight: bold;
  line-height: 17px;
  font-size: 1.4em;
  color: #aaaaab80;
}

.account-info-box p:last-child {
  font-weight: bold;
  line-height: 17px;
  font-size: 1.4em;
  margin-top: 15px;
  color: var(--label-secondary);
}

.hr {
  border-bottom: 1px solid #ffffff1f;
  margin-bottom: 30px;
  margin-top: 25px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.option {
  background: var(--box-up);
  padding: 45px;
  border-radius: 5px;
  color: #8c8c8c;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 50%;
  cursor: pointer;
}
.option:hover {
  background: #4b4f54;
}
.option i {
  color: #999999;
  margin-bottom: 20px;
}

@media screen and (min-width: 992px) {
  #store {
    margin-bottom: 30px;
  }
  #store > div:first-child {
    padding-right: 7.5px;
  }

  #store > div:last-child {
    padding-left: 7.5px;
  }
}

.infos {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.infos > i {
  font-size: 85px;
  color: #df465ccc;
}

.infos > .attention {
  font-size: 1.6em;
  font-weight: bold;
  color: #e56b7c;
  margin-top: 35px;
  margin-bottom: 15px;
  line-height: 19px;
}

.infos > .deactivate {
  font-size: 1.6em;
  font-weight: 300;
  color: #999999;
  line-height: 19px;
}

.date {
  color: #bbbbbb;
  line-height: 25px;
  border-top: 1px solid #47484c;
  border-bottom: 1px solid #47484c;
  padding: 15px 30px;
  font-weight: bold;
  font-size: 1.4em;
  margin-bottom: 30px;
  margin-top: 25px;
  text-align: center;
}

.losses {
  line-height: 25px;
  font-size: 1.4em;
  font-weight: 300;
  color: #bbbbbb;
  padding-top: 25px;
  margin-top: 25px;
  border-top: 1px solid #47484c;
}

.edit-input {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  color: var(--button-outline);
  background-color: var(--box-up);
  border: 1px solid #99999963;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  right: 5px;
  bottom: 21px;
}

.delete-account {
  color: var(--input-text);
  margin-top: 30px;
  line-height: 25px;
  font-size: 1.2em;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid transparent;
}

.delete-account:hover {
  border-bottom: 1px solid var(--input-text);
}

.send-code {
  margin-top: 20px;
  text-align: center;
  font-size: 1.3em;
  font-weight: 300;
  cursor: pointer;
  color: #777;
}

.account_payments_container {
  height: calc(100% - 140px);
}
.input-edit {
  position: relative;
}

@media screen and (max-width: 991px) {
  #store {
    margin-bottom: 20px;
  }

  .account-info-box p:first-child {
    font-weight: bold;
    line-height: 15px;
    font-size: 1.2em;
    color: #aaaaab80;
  }

  .account-info-box p:last-child {
    line-height: 15px;
    font-size: 1.2em;
    margin-top: 10px;
  }

  .account-title {
    margin-bottom: 15px;
  }
}
</style>
